import { request } from '@/utils/request'
const StationManageService = {
  state: {},

  mutations: {},

  actions: {
    // 项目设备分组列表
    getgroupingmanagement({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('Equipment/ProjectEnergyExt/GetGridJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存项目设备分组
    savegroupingmanagement({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('SystemManage/ItemsData/SubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除项目设备分组
    Deletegroupingmanagement({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('SystemManage/ItemsData/DeleteForm', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 项目设备分组左侧树
    getgroupingmanagementtree({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('Equipment/ProjectEnergyExt/GetTreeJsonNew', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 分配列表
    getAllocationlist({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('Equipment/EquipmentInfo/GetAllEquipment_Ext', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 通过树上点击的分组id获取项目id
    getprojectId({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('Equipment/EquipmentGroup/GetFormJsonX_Ext', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 分配设备
    getDistributionequipment({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/EquipmentGroup/EquipmentGroup_R_SubmitForm_Ext?groupID=' + params.groupID + '&rType=' + params.rType, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 移除设备
    DelDistributionequipment({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/EquipmentGroup/EquipmentGroup_R_Delete_Select_Ext', params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //  分组管理列表
    Groupmanagementlist({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('Equipment/ProjectEnergyExt/GetGroupInfoGridJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //  小类分组明细列表
    getGroupingDetails({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('Equipment/ProjectEnergyExt/GetTreeGridJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //  小类保存分组明细列表
    saveGroupingDetails({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/ProjectEnergyExt/GroupItemsSubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //  小类删除分组明细列表
    DelGroupingDetails({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/ProjectEnergyExt/GroupItemsDeleteFormByID', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取厂站下拉列表
    GetFactorystation({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/Station/GetAllStation', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //  大类保存分组明细列表
    saveGroupmanagementlist({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/ProjectEnergyExt/SubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //  大类删除分组明细列表
    DelGroupmanagementlist({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/ProjectEnergyExt/DeleteFormByID', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //  所属分类下拉
    GetClassification({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('Equipment/EquipmentClass/GetTreeSelectJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //  设备分项类型下拉
    GetEquipmentItemtype({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/ItemsData/GetSelectJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }

  }
}
export default StationManageService
